import Controller from "./corporateContractApprovals.controller";
import template from "./corporateContractApprovals.html";

const corporateContractApprovals = {
  template,
  controller: Controller,
};

export default corporateContractApprovals;



// WEBPACK FOOTER //
// ./src/pages/corporateContractApprovals/corporateContractApprovals.component.js